export default __webpack_public_path__ + "sync-success-icon.asset.0e59294b0387d23f3b667d852761f22d.svg";